// extracted by mini-css-extract-plugin
export default {"mindCard":"Therapy_mindCard__LY0Xg"};